import React from 'react';
import DownloadProgressModal from './DownloadProgressModal';

const CreateFilenameModal = () => {

    return (
        <div className="CreateFilenameModal">
            <div className="modal fade" id="createFilenameModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="CreateNewFilename" aria-hidden="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title spacer-inline" id="myModalLabel">Download Filename</div>
                            <button type="button" className="close" aria-label="Close" data-dismiss="modal">
                                <span aria-hidden="false">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-content-body">
                                <div className="descript-container">
                                    Enter a new name to identify your download file once it has been queued in the download status page.
                                </div>
                                <div className="modal-content-form">
                                    <label for="forgotUser">Create a new file name</label>
                                    <input required type="text" className="form-control" />
                                    <div className="field-wrapper sp-margin3 descript-container">
                                        Downloading may take several minutes to hours depending on the number of records and timeframe of the report.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal" data-target="#downloadProgressModal" data-toggle="modal">Initiate Download</button>
                            <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <DownloadProgressModal />
        </div>
    );
};


CreateFilenameModal.defaultProps = {};

export default CreateFilenameModal;
